// export const logo = require('@/assets/logo-full.png');
// export const drawerLogos = {
//     normal: require('@/assets/photo_2023-08-31_17-34-48.png'),
//     mini: require('@/assets/logo-white.png')
// };

// export const colors = {
//     primary: '#004a98',  
//     primaryLight: '#c0dfff',
//     secondary: '#f57f20',
//     lightBlue: '#8faecf'
// }

/* Ibn-alhaytham */
// export const logo = require('@/assets/logo-eng (2).png');
// export const drawerLogos = {
//     mini: require('@/assets/brands/ibn-alhaythem-mini.png'),
//     normal: require('@/assets/brands/ibn-alhaythem.png')
// };
// export const colors = {
//     primary: '#0b5b6f',  
//     primaryLight: '#c0dfff',
//     secondary: '#f57f20',
//     lightBlue: '#0996b9'
// }

/* alkhalil */
// export const logo = require('@/assets/Alkhalil.png');
// export const drawerLogos = {
//     normal: require('@/assets/Alkhalil-white.png'),
//     mini: require('@/assets/Alkhalil-white.png')
// }
// export const colors = {
//     primary: '#022044',  
//     primaryLight: '#2a669b',
//     secondary: '#156546',
//     lightBlue: '#2a669b',
//     lightGreenLighten: '#A5D6A7'
// }

/* Olabi Olabi */
// export const logo = require('@/assets/brands/Oulabi.png')
// export const drawerLogos = {
//     normal: require('@/assets/brands/oulabi-white.png'),
//     mini: require('@/assets/brands/oulabi-white.png')
    
// };
// export const colors = {
//     primary: '#534c49',
//     primaryLight: '#2d473c78',
//     secondary: '#a76647',
//     lightBlue: '#a67e56', // #0996b9 # # 0996b9 85b901 103aa2
// }

/* Mirta Mirta  */
// export const logo = require('@/assets/brands/logo-full.png')
// export const drawerLogos = {
//     normal: require('@/assets/brands/logo-full-white.png'),
//     mini: require('@/assets/brands/logo-full-white.png')
    
// };
// export const colors = {
//     primary: '#06572e',  
//     primaryLight: '#2d473c78',
//     secondary: '#e73525',
//     lightBlue: '#85b901', // #0996b9 # # 0996b9 85b901 103aa2
// }

// oubari
export const logo = require('@/assets/brands/OUBARI.png');
export const drawerLogos = {
    normal: require('@/assets/brands/Untitled-1.png'),
    mini: require('@/assets/brands/Untitled-1.png')
};
export const colors = {
    primary: '#253c99',  
    primaryLight: '#b2c1ff',
    secondary: '#f57f20',
    lightBlue: '#85b901'
}
